import BaseComponent from '@/components/base';
import Style from '@/components/before-after-carousel/style';
import { FontStyle } from '@/components/style';
import { addGlobalStylesToShadowRoot } from '@/components/global-styles';
import $ from 'jquery';
import 'slick-carousel';

export default class BeforeAfterCarousel extends BaseComponent {
  onConnect() {
    addGlobalStylesToShadowRoot(this.shadowRoot);
    $(`#before-after-slider-${this.getAttribute('type')}`).slick();
  }

  render() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productType = urlParams.get('product_type') || 'core';
    return this.productType === this.getAttribute('type')
      ? `${Style({ isMobile: this.isSmall })}
      ${FontStyle}
      <div class="wrapper" style="background: ${this.getAttribute('bgColor')}">
        <span class="eyebrow body-font-4">${this.getAttribute('eyebrow')}</span>
        <h3 class="headline title-font-5">
          <span>${this.getAttribute('headlinePrimary')}</span>
          <span>${this.getAttribute('headlineSecondary')}</span>
        </h3>
        <p class="description body-font-1">${this.getAttribute(
          'description'
        )}</p>
        <slot></slot>
        <span class="disclaimer body-font-3">${this.getAttribute(
          'disclaimer'
        )}</span>
      </div>`
      : '';
  }
}
